<template>
  <v-container class="fill-height pa-0" style="min-width: 350px" fluid>
    <v-img
      gradient="117deg, rgba(11,68,88,1) 0%, rgba(230,218,206,0.5) 53%,
rgba(132,105,110,1) 100%"
      height="100vh"
      src="../assets/images/pen-and-paper-todolist.jpg"
      width="100vw"
    >
      <v-row align="center" class="fill-height" justify="center">
        <v-col cols="12" class="text-center">
          <span class="white--text display-2 font-weight-light"
            >Infinite Todos&nbsp;<v-chip
              label
              class="font-weight-medium mb-10 hidden-xs-only"
              style="opacity: 1"
              disabled
              >BETA</v-chip
            >
          </span>

          <p class="white--text headline py-10">A minimalist todo app.</p>
          <v-row justify="center">
            <v-btn class="ma-2 white--text" color="blue darken-2" to="/signup"
              >Signup
            </v-btn>
            <v-btn
              outlined
              class="ma-2"
              style="border-width: 2px"
              color="white"
              to="/login"
              >Login
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-img>
  </v-container>
</template>
<script>
export default {
  name: 'Home',
}
</script>
